import request from '@utils/request'

export const createGroup = params => request.post('/api_v3/studio/page-group', params)

export const editGroup = params => {
    const { oldGroupName: name, name: newName } = params
    return request.put('/api_v3/studio/page-group', { newName, name })
}

export const removeGroup = name => request.delete(`/api_v3/studio/page-group?name=${encodeURIComponent(name)}`)
